<div class="timeTrack-modal">

  <!-- header -->
  <div class="row">
    <div class="col-12">
      <h3 class="text-manax m-0 mb-4">
        <span class="pull-right">
          <button mat-icon-button type="button" (click)="dialog.close()">
            <i class="material-icons">close</i>
          </button>
        </span>
        <span class="text-purple-manax text-capitalize title-modal">
          <span>
            {{action}}
          </span>
          Agente
        </span>
      </h3>
    </div>
  </div>

  <!-- body -->
  <div class="row" *ngIf="loading">
    <div class="col-12 mb-4">
      <div class="d-flex justify-content-center">
        <div class="spinner-border" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>
    </div>
  </div>

  <div class="row" *ngIf="!loading">
    <div class="col-12">
      <form *ngIf="form" class="m-0" [formGroup]="form" (ngSubmit)="onSubmit()">

        <div class="row mb-2">
          <div class="col-md-12">
            <mat-form-field appearance="outline">
              <mat-label> Nombre </mat-label>
              <input matInput name="name" formControlName="name" [readonly]="readOnly" required>
            </mat-form-field>
            <mat-error *ngIf="submitted && f['name']?.errors?.['required']">
              Nombre Obligatoria
            </mat-error>
          </div>
        </div>

        <div class="row mb-2">
          <div class="col-md-12">
            <mat-form-field appearance="outline">
              <mat-label> Telefono </mat-label>
              <input matInput name="phone" formControlName="phone" type="number" class="text-left"
                [readonly]="readOnly">
            </mat-form-field>
          </div>
        </div>

        <div class="row mb-2">
          <div class="col-md-12">
            <mat-form-field appearance="outline">
              <mat-label> Email </mat-label>
              <input matInput name="email" formControlName="email" type="email" [readonly]="readOnly">
            </mat-form-field>
          </div>
        </div>

        <div class="row" *ngIf="!readOnly">
          <div class="col-12 pt-4">
            <button mat-raised-button [disabled]="saving" type="submit" class="m-0 ml-1 pull-right btn btn-manax">
              <span *ngIf="saving" class="spinner-border spinner-border-sm mr-1"></span>
              Guardar
            </button>
            <button mat-raised-button type="button" class="m-0 ml-1 pull-right btn btn-link"
              (click)="dialog.close(false)">
              Cancelar
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>